import * as React from 'react';

import type {SalesAutomationStage as SalesAutomationStageFragment} from 'nutshell-graphql-types';

import {SAGoalsFeatureGate} from '../../../../ui/limits/feature-gates/sales-automation-goals-feature-gate';

import {GOALS} from '../../constants';
import {SAGoalsCtaBanner} from '../../ctas/goals-cta-banner';

import {calculateBoardWidth} from '../calculate-board-width';
import {StageCardsGoalsContainer} from '../card-containers/stage-cards-goals-container';

import {CollapsibleSection} from './collapsible-section';

type Props = {
    stages: SalesAutomationStageFragment[];
    hideCards: boolean;
};

/*
 * Top-level component responsible for rendering the entire "goals"
 * section (row) on the sales automation setup board.
 */
export function SalesAutomationGoals(props: Props) {
    const [isFeatureGateModalOpen, setIsFeatureGateModalOpen] = React.useState(false);

    const collapsibleSectionContents = NutCapabilities.SAGoals.isAvailable ? (
        props.stages.map((stage) => {
            return (
                <StageCardsGoalsContainer
                    key={stage.id}
                    hideCards={props.hideCards}
                    parentId={stage.id}
                />
            );
        })
    ) : (
        <SAGoalsCtaBanner
            width={calculateBoardWidth(props.stages.length)}
            onClick={() => setIsFeatureGateModalOpen(true)}
        />
    );

    return (
        <>
            <CollapsibleSection type={GOALS}>{collapsibleSectionContents}</CollapsibleSection>
            <SAGoalsFeatureGate
                isOpen={isFeatureGateModalOpen}
                setIsOpen={setIsFeatureGateModalOpen}
            />
        </>
    );
}
